import { ReportModalBean } from "../../report/ReportModalBean";
import { USERREPORT_ACCOUNTROUTE } from "../../../views/accounts/AccountController";
import { downloadSettingsValueKey } from "fides-angularjs-components/src/fts-administration/fts-exportDownload-settings/fts-download-settings";
import { EXPORT_TYPE } from "../../export/ExportModalController";
import { ExportModalBean } from "../../export/ExportModalBean";
import { EXPORT_MODAL } from "../../../routes/export.route";

/** @ngInject */
export class ReactExportController {
    constructor($scope, getSelectedRowsIds, ftsMainDependencies, arsMainDependencies, supportedExports, reportOptions) {
        this.$scope = $scope;
        this.ftsMainDependencies = ftsMainDependencies;
        this.$rootScope = this.ftsMainDependencies.$rootScope;
        this.$mdDialog = arsMainDependencies.$mdDialog;
        this.state = arsMainDependencies.$state;
        this.exportText = $scope.exportText || 'EXPORT_CSV_HOOVER';
        this.supportedExports = supportedExports;
        this.reportOptions = reportOptions;
        this.getSelectedRowsIds = getSelectedRowsIds;
        this.REPORT_MODAL = {
            templateUrl: 'app/components/report/report-modal.html',
            controller: 'ReportModalController',
            controllerAs: 'vm',
            size: 'md',
            backdrop: 'static',
            keyboard: false,
            multiple: true,
            resolve: { reportModalBean: () => new ReportModalBean(
                this.reportOptions.options, this.reportOptions.withDateRange, this.reportOptions.withLastAndUnread) }
        };

        this.USERREPORTSTATE = this.state.get(USERREPORT_ACCOUNTROUTE);
        this.USER_REPORT_MODAL = {
            templateUrl: this.USERREPORTSTATE.templateUrl,
            controller: this.USERREPORTSTATE.controller,
            controllerAs: this.USERREPORTSTATE.controllerAs,
            backdrop: 'static',
            keyboard: false,
            multiple: true
        };

        let totalElements = 0;
        $scope.$on('populated', (event, params) => {
            totalElements = totalElements + params.length;
            // different multiple selection on different groups selection
            this.state._params.ids =  !_.isNil(this.state._params.ids) ?
                this.state._params.ids.concat(params) : params;
            if(totalElements === this.$rootScope.checkElements) {
                // option for multiple groups indiv. selection, from report filter component
                this.showAndResetUserReport();
            }
        });
    }

    checkSelectedIems() {
        this.$scope.parentController.checkForSelection();
        if(this.$rootScope.checkElements === 0 ){
            this.$scope.parentController.infoPop('NO_ROW_SELECTED');
            return false;
        } else if(this.$rootScope.overLimit) {
            return false;
        }

        return this.$rootScope.overLimit ? false : true;
    }

    checkExport() {
        const userSettings = this.ftsMainDependencies.sessionPersistance.get(downloadSettingsValueKey);
        const exportFormat = userSettings ? userSettings.exportFormat : 'SETTINGS_EXPORTFORMAT_OPTION_NONE';

        this.$rootScope.exportFromGroup = false;
        if(exportFormat === 'SETTINGS_EXPORTFORMAT_OPTION_NONE') {
            this.openExport();
        } else {
            this.broadcastOption(
                exportFormat === 'SETTINGS_EXPORTFORMAT_OPTION_CSV' ? EXPORT_TYPE.CSV : EXPORT_TYPE.XLS);
        }
    }

    openExport() {
        //delete possible group definition
        EXPORT_MODAL.resolve = { exportModalBean: () =>
                new ExportModalBean(this.supportedExports,{tableId: this.$scope.tableId},undefined)};
        this.openPopup(EXPORT_MODAL);
    }

    openReport(consolidationCurrency, tableFilter, isAllSelected, tableCount, sort) {
        // accounts & val series report
        this.state._params = this.USERREPORTSTATE.params;
        this.state._params.consolitationcurrency = consolidationCurrency.code ?
            consolidationCurrency.code : consolidationCurrency;
        this.state._params.fileType = this.reportOptions;
        this.state._params.selectAll = isAllSelected;
        this.state._params.tableFilter = tableFilter;
        this.state._params.sort = sort;
        delete this.state._params.group;
        // select All option
        if(this.state._params.selectAll) {
            this.state._params.tableCount = tableCount;
            this.showAndResetUserReport();
        }else {
            this.state._params.ids = this.getSelectedRowsIds();
            this.showAndResetUserReport();
        }
    }

    showAndResetUserReport() {
        this.$mdDialog.show(this.USER_REPORT_MODAL).catch(() => {
            // reset for next selection
            this.$rootScope.checkElements = 0;
            this.state._params.ids = [];
        });
    }

    openPopup(popUpOption) {
        this.$mdDialog.show(popUpOption).catch(() => this.$rootScope.checkElements = 0); // reset for next selection
    }

    broadcastOption(selectedExport){
        this.$rootScope.$broadcast('export', {reportType: selectedExport, userFunction: selectedExport.userFunction });
    }
}
